module.exports = __webpack_public_path__ + "231d16066bb902a9c38b8ff8d7ff5a40.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pili/AppData/Roaming/npm/~/pink/css/fonts/LeagueGothic/leaguegothic-condensed-italic-webfont.ttf
// module id = 362
// module chunks = 0